
export type MSReasonsforNoDmtOptions = {
    [key: string]: string;
};

export enum MSReasonsForNoDmtTypes {
  NotOffered = "I haven't been offered a DMT",
  NotEligible = "I'm not eligible to start on a DMT",
  NotTakingForNow = "I've decided to not take a DMT for now",
  ConsideringOptions = "I'm considering my options before I decide which DMT to select",
  WaitingForTeam = "I'm waiting for my MS team to organise my DMT",
}


const MSReasonsForNoDmt: MSReasonsforNoDmtOptions = {
  NotOffered: "I haven't been offered a DMT",
  NotEligible: "I'm not eligible to start on a DMT",
  NotTakingForNow: "I've decided to not take a DMT for now",
  ConsideringOptions: "I'm considering my options before I decide which DMT to select",
  WaitingForTeam: "I'm waiting for my MS team to organise my DMT", 
}

export default MSReasonsForNoDmt;
